import { Component, OnInit, OnDestroy } from '@angular/core'; 
import { SearchService } from './services/search.service';
import { Router,NavigationError } from '@angular/router';
import { TraceLogFlushService } from './services/trace-log-flush.service';
import { TraceLogService } from './services/trace-log.service';
import { ErrorsHandler } from './services/error-handler';
import { AuthorizationService } from './services/authorization.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit,OnDestroy {
  title = 'Modernize Angular Admin Tempplate';

  constructor(private sessionTimeout: SearchService,private authorizationService: AuthorizationService,private router: Router,private traceLogFlushService: TraceLogFlushService,private traceLogService: TraceLogService,private errorsHandler: ErrorsHandler ) {}

   ngOnInit(): void {
    this.sessionTimeout.start();
    this.traceLogFlushService.start();
    this.errorsHandler.registerGlobalListeners();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        this.traceLogService.logEvent('NAV-ERROR', 'nav-error', {
          url: event.url,
          errorMessage: event.error?.message || 'Navigation failed'
        });
        this.traceLogFlushService.flush();
      }
    });
  }
  ngOnDestroy(): void {
    // Stop the trace logging timer when app closes
    this.traceLogFlushService.stop();
  }  
}
